export const DEFAULT_BUSINESS_HOURS = [
    {
        dayOfWeek: 0,
        closed: true,
        openTime: null,
        closeTime: null,
        breakStartTime: null,
        breakEndTime: null,
    },
    {
        dayOfWeek: 1,
        closed: false,
        openTime: "10:00",
        closeTime: "18:00",
        breakStartTime: null,
        breakEndTime: null,
    },
    {
        dayOfWeek: 2,
        closed: false,
        openTime: "10:00",
        closeTime: "18:00",
        breakStartTime: null,
        breakEndTime: null,
    },
    {
        dayOfWeek: 3,
        closed: false,
        openTime: "10:00",
        closeTime: "18:00",
        breakStartTime: null,
        breakEndTime: null,
    },
    {
        dayOfWeek: 4,
        closed: false,
        openTime: "10:00",
        closeTime: "18:00",
        breakStartTime: null,
        breakEndTime: null,
    },
    {
        dayOfWeek: 5,
        closed: false,
        openTime: "10:00",
        closeTime: "18:00",
        breakStartTime: null,
        breakEndTime: null,
    },
    {
        dayOfWeek: 6,
        closed: false,
        openTime: "11:00",
        closeTime: "16:00",
        breakStartTime: null,
        breakEndTime: null,
    },
];
export const DEFAULT_BOOKING_TYPES = {
    VERDIVURDERING: {
        enabled: true,
        label: "Verdivurdering",
        durationMinutes: 30,
        description: "Få en uforpliktende vurdering av smykkene dine.",
        stations: 1,
        priceNok: 0,
    },
    SALG: {
        enabled: true,
        label: "Salg",
        durationMinutes: 45,
        description: "Selg gull og motta utbetaling.",
        stations: 1,
        priceNok: 0,
    },
    ANALYSE: {
        enabled: false,
        label: "Analyse",
        durationMinutes: 60,
        description: "Avansert materialanalyse av smykker.",
        stations: 1,
        priceNok: 0,
    },
};
export const DEFAULT_SLOT_INTERVAL_MINUTES = 30;
export const DEFAULT_STAFF_COUNT = 2;
export const DEFAULT_BOOKING_HORIZON_DAYS = 90;
export const MAX_BOOKING_HORIZON_DAYS = 365;
export const DEFAULT_MIN_NOTICE_MINUTES = 0;
export const MAX_MIN_NOTICE_MINUTES = 20160;
export const DEFAULT_REQUIRE_LOGIN = true;
